exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-38881c90]{border-top:1px solid #004aa0;color:#fff;display:block;font-size:1.25rem;font-weight:300;line-height:1;padding:.5rem 1rem .8rem;text-transform:capitalize;transition:all .2s}a[data-v-38881c90]:hover{color:#badaff;text-decoration:none}a.router-link-active[data-v-38881c90]{background-color:#002754;color:#badaff}.icon[data-v-38881c90]{margin-right:.5rem;position:relative;top:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38881c90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/nav/NavItem.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-38881c90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/nav/NavItem.vue
// module chunks = 0